import { createSelector } from 'reselect';

const constructionSelector = (state) => state.Construction;

export default createSelector(
  constructionSelector,
  (construction) => ({
    loaded: construction.parameters_loaded,
    hole_back_count_available: [...construction.available.hole_back_count],
    hole_back_count_info: construction.info.hole_back_count,
    hole_back_count_selected: construction.selected.hole_back_count,
    hole_back_size_available: [...construction.available.hole_back_size],
    hole_back_size_info: construction.info.hole_back_size,
    hole_back_size_selected: construction.selected.hole_back_size,
    hole_front_count_available: [...construction.available.hole_front_count],
    hole_front_count_info: construction.info.hole_front_count,
    hole_front_count_selected: construction.selected.hole_front_count,
    hole_front_size_available: [...construction.available.hole_front_size],
    hole_front_size_info: construction.info.hole_front_size,
    hole_front_size_selected: construction.selected.hole_front_size,
    hole_left_count_available: [...construction.available.hole_left_count],
    hole_left_count_info: construction.info.hole_left_count,
    hole_left_count_selected: construction.selected.hole_left_count,
    hole_left_size_available: [...construction.available.hole_left_size],
    hole_left_size_info: construction.info.hole_left_size,
    hole_left_size_selected: construction.selected.hole_left_size,
    hole_right_count_available: [...construction.available.hole_right_count],
    hole_right_count_info: construction.info.hole_right_count,
    hole_right_count_selected: construction.selected.hole_right_count,
    hole_right_size_available: [...construction.available.hole_right_size],
    hole_right_size_info: construction.info.hole_right_size,
    hole_right_size_selected: construction.selected.hole_right_size
  })
);
